import isUndefined from 'lodash/isUndefined'
import React from 'react'
import styled from 'styled-components'
import LayersLogo from './LayersLogo'
import { UIStyles, surfaces } from '../../theme'

// The frosted glass of the map loader: the page blurs behind it while it loads.
const Wrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  height: 100vh;
  background-color: ${UIStyles.blueColorOpacity};
  -webkit-backdrop-filter: ${surfaces.glassBackdropFilter};
  backdrop-filter: ${surfaces.glassBackdropFilter};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${props => (isUndefined(props.zIndex) ? 100 : props.zIndex)};
`

const Loader = props => {
  const { isLoading } = props
  if (!isLoading) return null

  if (props.component)
    return (
      <Wrapper>
        <component />
      </Wrapper>
    )

  return (
    <Wrapper zIndex={props.zIndex}>
      <LayersLogo />
    </Wrapper>
  )
}

Loader.defaultProps = {
  isLoading: true
}

export default Loader
